function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { notificationSettingsModel } from "../../models";
export let Tab = /*#__PURE__*/function (Tab) {
  Tab["Vendor"] = "vendor";
  Tab["Client"] = "customer";
  return Tab;
}({});
export let Table = /*#__PURE__*/function (Table) {
  Table["Notifications"] = "notifications";
  Table["Reminders"] = "reminders";
  return Table;
}({});
export const notificationColumnDefs = [{
  width: 480
}, {
  width: 160
}, {
  width: 200
}];
export const notificationHeaderItems = [{
  value: 'Event Name'
}, {
  value: 'Status'
}, {
  value: 'Notified Team Member'
}];
const clientReminderColumnDefs = [{
  width: 340
}, {
  width: 60
}, {
  width: 80
}, {
  width: 20
}, {
  width: 200
}];
const clientReminderHeaderItems = [{
  value: 'Delayed Action'
}, {
  value: 'Status'
}, {
  value: 'Interval'
}, {
  value: 'Retries'
}, {
  value: 'Notified Team Member'
}];
const vendorReminderColumnDefs = [{
  width: 400
}, {
  width: 80
}, {
  width: 100
}, {
  width: 200
}];
const vendorReminderHeaderItems = [{
  value: 'Delayed Action'
}, {
  value: 'Status'
}, {
  value: 'Delay'
}, {
  value: 'Notified Team Member'
}];
export const reminderColumnDefsMap = {
  [Tab.Vendor]: vendorReminderColumnDefs,
  [Tab.Client]: clientReminderColumnDefs
};
export const reminderHeaderItemsMap = {
  [Tab.Vendor]: vendorReminderHeaderItems,
  [Tab.Client]: clientReminderHeaderItems
};
function getVendorNotificationToShowTextMap(_ref) {
  let {
    showKarbonIntegration,
    showClientHubIntegration,
    showFinancialCentsIntegration
  } = _ref;
  const map = {
    relationshipApprovedVendor: 'Proposal signed',
    relationshipAmendmentsApprovedVendor: 'Amendment approved',
    paymentFailedVendor: 'Payment failed',
    invoiceRefundedVendor: 'Payment refunded',
    invoiceRefundFailedVendor: 'Refund failed',
    payoutDepositedVendor: 'Payout deposited',
    proposalNotSignedReminderVendor: 'Proposal not signed',
    amendmentsNotApprovedReminderVendor: 'Amendment not approved',
    bankAccountNotVerifiedReminderVendor: 'Bank account not verified',
    payoutFailedVendor: 'Payout failed'
  };
  if (showFinancialCentsIntegration) map.relationshipFinancialCentsFailedItems = 'Financial Cents project creation failed';
  if (showKarbonIntegration) map.relationshipKarbonFailedItems = 'Karbon work item creation failed';
  if (showClientHubIntegration) map.relationshipClientHubFailedItems = 'Client Hub project creation failed';
  return map;
}
const getClientNotificationToShowTextMap = _ref2 => {
  let {
    featureFlags
  } = _ref2;
  return _objectSpread(_objectSpread({
    invoiceIssuedAutoProcess: 'Invoice issued'
  }, (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.USE_NEW_RELATIONSHIP_APPROVED_CUSTOMER_TEMPLATE) && {
    relationshipApprovedCustomer: 'Agreement approved'
  }), {}, {
    invoiceIssuedRequiresApproval: 'Invoice requires approval',
    paymentFailedCustomer: 'Payment failed',
    relationshipUpdatedWithChanges: 'Agreement amended',
    invoiceRefundedCustomer: 'Payment refunded',
    proposalNotSignedReminderCustomer: 'Proposal not signed',
    amendmentApprovalReminderCustomer: 'Amendment not approved',
    bankAccountNotVerifiedReminderCustomer: 'Bank account not verified'
  });
};
export function getNotificationsToShow(opts) {
  const getTextMap = opts.tab === Tab.Vendor ? getVendorNotificationToShowTextMap : getClientNotificationToShowTextMap;
  return getTextMap(opts);
}
const vendorProposalNotifications = ['proposalNotSignedReminderVendor', 'relationshipApprovedVendor'];
export const getRecipientTypeTextMap = notificationName => ({
  all: notificationName === 'proposalNotSignedReminderCustomer' ? "Primary Contact\nSignatories" : 'All team members',
  owner: 'Owner',
  admin: 'Admin',
  assignee: vendorProposalNotifications.includes(notificationName) ? 'Sender' : 'Assigned Team Member'
});
export const getEditDropdownRecipientTypeText = notificationName => ({
  all: 'All team members',
  owner: 'Users with Owner role',
  admin: 'Users with Admin role',
  assignee: vendorProposalNotifications.includes(notificationName) ? 'Sender' : 'Assigned Team Member'
});
export const getRecipientTypesText = (recipientTypes, notificationName) => recipientTypes.includes('all') ? [getRecipientTypeTextMap(notificationName).all] : recipientTypes.map(recipientType => getRecipientTypeTextMap(notificationName)[recipientType]);
export const minutesToDays = minutes => Math.floor(minutes / 60 / 24);
export const daysToMinutes = days => days * 60 * 24;
export const isDays = minutes => minutes % (60 * 24) === 0;
export const handleSetRecipientTypes = _ref3 => {
  let {
    newType,
    newRecipientTypes,
    setRecipientTypes
  } = _ref3;
  setRecipientTypes(newRecipientTypes.includes('all') ? newType === 'all' ? ['all'] : newRecipientTypes.filter(x => x !== 'all') : newRecipientTypes);
};
export const getFallbackRecipientTypes = _ref4 => {
  let {
    recipientTypes,
    defaultRecipientType,
    originalRecipientTypes
  } = _ref4;
  return notificationSettingsModel.hasRecipients({
    recipientTypes
  }) ? [] : notificationSettingsModel.hasRecipients({
    recipientTypes: originalRecipientTypes
  }) ? originalRecipientTypes : [defaultRecipientType];
};